import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { showLiveViewModal } from '../../utils/liveView/showLiveViewModal'
import { playItem } from '../../utils/playItem'
import { createPoll } from '../../utils/createPoll'
import { showNotification } from '../../actions/notifications'
import { updatePreviewItem } from '../../actions/previewItem'
import { getQuestionBodyLabel } from '../../utils/getQuestionBodyLabel'
import SectionSelection from '../../components/modals/SectionSelection'

class SectionSelectionContainer extends Component {
  constructor() {
    super()
    this.selectSection = this.selectSection.bind(this)
  }

  // A class was picked. What that means depends on the mode the picker was
  // opened in — see the branches below.
  selectSection(sectionId) {
    const { mode, itemToPlay, sections } = this.props
    this.props.hideModal()
    // 'queue' mode enqueues the item for the chosen class and surfaces a
    // notification, without leaving the current page. Default 'play' mode
    // starts a Live View session as before.
    if (mode === 'queue') {
      const section = sections.find((s) => s.id === sectionId)
      // Sets carry a name; questions fall back to their body label so a
      // media-only question reads as "Media Only Question" rather than blank.
      const itemLabel = itemToPlay.name || getQuestionBodyLabel(itemToPlay)
      const sectionName = section ? section.name : 'class'
      // The modal is already closed by this point, so a failure has to be
      // reported by notification or it goes entirely unnoticed. The newSetPoll /
      // newQuestionPoll thunks handle their own rejection (FAILURE action +
      // Sentry) and resolve with undefined, so failure is detected from the
      // resolved value rather than a rejection; the catch covers an unexpected
      // throw.
      Promise.resolve(this.props.createPoll(itemToPlay, sectionId))
        .then((response) => {
          if (!response) {
            this.props.showNotification(`to queue ${itemLabel} for ${sectionName}`, 'Failed', 'destroy')
            return
          }
          this.props.showNotification(`${itemLabel} for ${sectionName}`, 'Queued', 'default')
        })
        .catch(() => {
          this.props.showNotification(`to queue ${itemLabel} for ${sectionName}`, 'Failed', 'destroy')
        })
      return
    }
    // Picking a class in play mode starts Live View — close any lightweight
    // preview that launched this picker so it isn't left mounted behind it
    // (no-op when the picker was opened outside the preview).
    this.props.updatePreviewItem(null)
    this.props.playItem(itemToPlay, sectionId)
    showLiveViewModal()
  }

  render() {
    return (
      <SectionSelection sections={this.props.sections} item={this.props.itemToPlay} mode={this.props.mode} hideModal={this.props.hideModal} selectSection={this.selectSection} />
    )
  }
}

export default withRouter(connect(
  (state) => ({
    sections: state.sections,
    itemToPlay: state.modals.itemToPlay,
    mode: state.modals.sectionSelectionMode,
  }),
  {
    playItem, createPoll, showNotification, updatePreviewItem,
  },
)(SectionSelectionContainer))
